import {
  UPDATE_RESET_USER_NAME_EMAIL,
  UPDATE_RESET_USER_NAME_MOBILE,
  UPDATE_SUBMIT_LOADING,
  CHANGE_CUR_TAB,
  UPDATE_CHECKED_AGREEMENTS,
  UPDATE_AGREEMENTS_STATUS,
  AGREEMENTS_STATUS_LOADING,
} from '../actions/customerResetUserNameAction';

import { UPDATE_VERIFY_CURRENT_PASSWORD_LOADING } from '../actions/customerResetUsernameVerifyPasswordAction';

const defaultState = {
  isSubmitLoading: false,
  email: '',
  mobile: '',
  curUserNameTab: '',
  isAgreementsStatusLoading: false,
  isVerifyCurrentPasswordLoading: false,
  agreementsStatus: {},
};

export default (state: any = defaultState, action: any) => {
  const nextState = { ...state };
  switch (action.type) {
    case UPDATE_RESET_USER_NAME_EMAIL:
      nextState.email = action.email || '';
      return nextState;
    case UPDATE_RESET_USER_NAME_MOBILE:
      nextState.mobile = action.mobile || '';
      return nextState;
    case CHANGE_CUR_TAB:
      nextState.curUserNameTab = action.curUserNameTab || '';
      return nextState;
    case UPDATE_CHECKED_AGREEMENTS:
      nextState.checkedAgreements = action.checkedAgreements || {};
      return nextState;
    case UPDATE_AGREEMENTS_STATUS:
      nextState.agreementsStatus = action.agreementsStatus || {};
      return nextState;
    case AGREEMENTS_STATUS_LOADING:
      nextState.isAgreementsStatusLoading =
        action.isAgreementsStatusLoading || false;
      return nextState;
    case UPDATE_SUBMIT_LOADING:
      nextState.isSubmitLoading = action.isSubmitLoading || false;
      return nextState;
    case UPDATE_VERIFY_CURRENT_PASSWORD_LOADING:
      nextState.isVerifyCurrentPasswordLoading =
        action.isVerifyCurrentPasswordLoading || false;
      return nextState;
    default:
      return nextState;
  }
};
